"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var clientWorkOrder_1 = __importDefault(require("./clientWorkOrder"));
var geographicAddress_1 = __importDefault(require("./geographicAddress"));
var meterInfo_1 = __importDefault(require("./meterInfo"));
var clientWorkOrders = /** @class */ (function () {
    function clientWorkOrders(payload, translations) {
        var _this = this;
        this.clientWorkOrderList = new Array();
        payload.clientWorkOrderList.forEach(function (element) { return _this.clientWorkOrderList.push(new clientWorkOrder_1.default(element, translations)); });
        this.geographicAddress = new geographicAddress_1.default(payload.geographicAddress);
        this.meter = new meterInfo_1.default(payload.meter);
        this.displayClientWorkOrderEndDate = payload.displayClientWorkOrderEndDate;
    }
    return clientWorkOrders;
}());
exports.default = clientWorkOrders;
